import type AuthenticationContext from './AuthenticationContext'
import { getImpersonatedUserId } from './impersonationStore'
import { extractProfileClaims } from './profileClaims'
import userManager from './userManager'

const requireAuthContext = async (): Promise<AuthenticationContext> => {
  let user = await userManager.getUser()
  if (!user || !user.access_token || user.expired) {
    user = await userManager.signinSilent().catch(() => null)
  }
  if (!user || !user.access_token || user.expired) throw new Error('Not authenticated. Please sign in and try again.')

  const { organizationId, userEntityId, syncUserId } = extractProfileClaims(user.profile)
  if (!organizationId || !userEntityId || !syncUserId)
    throw new Error(
      'Authentication context is missing. This may be because your user account is not linked to a user entity. Please contact support for assistance.'
    )

  return {
    accessToken: user.access_token,
    organizationId,
    userEntityId,
    syncUserId,
    impersonatedUserId: getImpersonatedUserId(),
  }
}

export default requireAuthContext
